module.exports = __webpack_public_path__ + "img/6_ward.afbfac54.png";